export default __webpack_public_path__ + "static/2017-e10e9911ba4f38fd1462a57cab596635.gif";